// extracted by mini-css-extract-plugin
export default {"container":"EmergencyClassificationInfo_container__hH0R1"};